/* @flow */

import { includes } from "lodash";
import type { CountryMetadata } from "./types";

const countryLookup = require("country-data").lookup;

export const SUPPORTED_EU_COUNTRY_CODES: string[] = [
  "AND",
  "AUT",
  "BEL",
  "BGR",
  "GGY",
  "GIB",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "ISL",
  "IMN",
  "IRL",
  "ITA",
  "JEY",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MLT",
  "MCO",
  "NLD",
  "NOR",
  "POL",
  "PRT",
  "ROU",
  "SMR",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "CHE",
  "GBR"
];

export const SUPPORTED_APAC_COUNTRY_CODES: string[] = ["MYS", "SGP", "HKG"];

export const SUPPORTED_LOCAL_ACQUIRING_COUNTRY_CODES: string[] = ["BRA"];

// Countries for which the contact form collects an explicit nationality.
// Derived from the DTBTPROV nationality requirement, excluding countries not
// supported by the signup form (French Guiana, Guadeloupe, Holy See/Vatican
// City, Martinique, Mayotte, Réunion). MYS and SGP collect nationality for
// all contacts on their direct signup flows.
export const NATIONALITY_SUPPORTED_COUNTRY_CODES: string[] = [
  "AUT",
  "BEL",
  "BGR",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "IRL",
  "ITA",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MLT",
  "NLD",
  "NOR",
  "POL",
  "PRT",
  "ROU",
  "SMR",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "MYS",
  "SGP"
];

export const SUPPORTED_COUNTRY_CODES: string[] = [
  ...SUPPORTED_EU_COUNTRY_CODES,
  ...SUPPORTED_APAC_COUNTRY_CODES,
  "USA",
  "AUS",
  "NZL"
];

export const SUPPORTED_COUNTRIES_METADATA: CountryMetadata[] = SUPPORTED_COUNTRY_CODES.map(
  (countryCode: string) => {
    const country = countryLookup.countries({ alpha3: countryCode })[0];
    return {
      name: country.name,
      countryCode: country.alpha3,
      countryCodeShort: country.alpha2,
      currencyISOCode: country.currencies[0],
      phoneCode: country.countryCallingCodes[0]
    };
  }
);

export const SUPPORTED_EU_COUNTRIES_METADATA: CountryMetadata[] = SUPPORTED_EU_COUNTRY_CODES.map(
  (countryCode: string) => {
    const country = countryLookup.countries({ alpha3: countryCode })[0];
    return {
      name: country.name,
      countryCode: country.alpha3,
      currencyISOCode: country.currencies[0],
      phoneCode: country.countryCallingCodes[0]
    };
  }
);

export const findRegionByCode = (code: string): string => {
  switch (code) {
    case "AUS":
    case "MYS":
    case "HKG":
    case "SGP":
    case "NZL":
      return "Asia-Pacific";
    case "USA":
    case "CAN":
      return "North America";
    default:
      return "European Union";
  }
};

export const isEurope = (countryCode: string): boolean => {
  return includes(SUPPORTED_EU_COUNTRY_CODES, countryCode);
};

export const isDDARequired = (countryCode: string): boolean => {
  return countryCode === "AUS";
};
